export default {"src":"/_next/static/media/logo-mobile.d4f6db8e.svg","height":27,"width":85};